<template>
    <div class="collect-card" @click.stop="open_picture_list(data.id)">
        <div class="card-cover" :count="`${data.cover.length}`">
            <template v-if="data.cover.length">
                <div
                    v-for="(item, i) in data.cover"
                    :key="i"
                    :class="`covers cover-${i + 1}`"
                    :style="`background-image:url(${item});`"
                />
            </template>
            <template v-else>
                <div class="tips">
                    <h4>{{ $TL.noAddImg }}</h4>
                </div>
            </template>
            <v-btn class="edit-card" @click.stop="edit_favorites">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </div>
        <div class="card-info">
            <p class="collect-title">{{ data.name }}</p>
            <span class="desc">{{ data.fav_count }} {{ $TL.zPictures }}</span>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
    name: "collect-card",
    props: {
        data: {
            type: Object,
            default: () => {
                return {};
            }
        },
        index: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {};
    },
    computed: {
        ...mapState("favorites", ["favoritesIndex"])
    },
    created() {
        this.$P.$on("updateFavoritesName", (name, id) => {
            if (this.index !== this.favoritesIndex) return;
            this.data.name = name;
            this.updateFavoritesName(name);
        });
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        ...mapMutations("favorites", [
            "updateFavoritesId",
            "updateFavoritesName",
            "updateFavoritesIndex",
            "updateFavoritesAmount"
        ]),
        ...mapMutations("triggerEvtents", ["updateSnackbar"]),

        open_picture_list(id) {
            if (this.data.fav_count > 0) {
                this.updateFavoritesId(this.data.id);
                this.updateFavoritesName(this.data.name);
                this.updateFavoritesAmount(this.data.fav_count);
                this.$router.push(
                    `/favorites-details?name=${this.data.name}&fav_count=${this.data.fav_count}&id=${this.data.id}`
                );
            } else {
                this.updateSnackbar(this.$TL.noPicturesAddedYet);
            }
        },
        edit_favorites() {
            this.updateFavoritesId(this.data.id);
            this.updateFavoritesIndex(this.index);
            this.updateFavoritesName(this.data.name);
            this.$store.state.vModal.showType = "editFavorites";
        }
    }
};
</script>

<style lang="scss">
.collect-card {
    margin-bottom: 24px;
    padding: 0 12px;
    width: 16.65%;
    cursor: pointer;

    &:hover {
        .card-cover img {
            transform: scale(1.08) translateX(-50%);
        }
    }

    .card-cover {
        width: 100%;
        padding-top: 72.88%;
        border-radius: $border-radius;
        overflow: hidden;
        position: relative;
        background-color: rgba(0, 0, 0, 0.03);

        &:hover {
            .edit-card {
                display: flex;
            }
        }

        .covers {
            position: absolute;
            background: {
                repeat: no-repeat;
                position: center center;
                size: cover;
            }
        }
        .cover-1 {
            width: 62%;
            height: 100%;
            top: 0;
            left: 0;
        }

        .cover-2,
        .cover-3 {
            width: 37%;
            height: 49.42%;
            right: 0;
        }

        .cover-2 {
            top: 0;
            border-bottom-right-radius: 4px;
        }

        .cover-3 {
            bottom: 0;
            border-top-right-radius: 4px;
        }

        .tips {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            @include flex(center, center);
            padding: 20px;

            h4 {
                font-size: 16px;
                font-weight: normal;
            }
        }
    }

    .edit-card {
        position: absolute;
        bottom: 4px;
        right: 5px;
        background-color: $color-white;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        z-index: 22;
        box-shadow: 0px 3px 4px rgba(#000, 0.16);
        display: none;
        align-items: center;
        justify-content: center;

        i {
            font-size: 16px;
        }
    }

    .card-info {
        margin-top: 12px;

        .collect-title {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 4px;
        }

        .desc {
            font-size: 12px;
            color: #3c4043;
        }
    }

    .card-cover {
        &[count="1"] {
            .cover-1 {
                width: 100%;
            }
        }
        &[count="2"] {
            .cover-1 {
                width: 62%;
            }
            .cover-2 {
                width: 37%;
                height: 100%;
            }
        }
    }

    @media (max-width: 1600px) {
        width: 20%;
    }

    @media (max-width: 1400px) {
        width: 25%;
    }
}
</style>
